export const ADD_PRE_ASSESSMENT_DATA = "ADD_PRE_ASSESSMENT_DATA";
export const ADD_PRE_ASSESSMENT_DATA_SUCCESS = "ADD_PRE_ASSESSMENT_DATA_SUCCESS";
export const ADD_PRE_ASSESSMENT_DATA_FAILURE = "ADD_PRE_ASSESSMENT_DATA_FAILURE";

export const FETCH_PRE_ASSESSMENT_VIDEO = "FETCH_PRE_ASSESSMENT_VIDEO";
export const FETCH_PRE_ASSESSMENT_VIDEO_SUCCESS = "FETCH_PRE_ASSESSMENT_VIDEO_SUCCESS";
export const FETCH_PRE_ASSESSMENT_VIDEO_FAILURE = "FETCH_PRE_ASSESSMENT_VIDEO_FAILURE";

export const FETCH_PRE_ASSESSMENT_DATA = "FETCH_PRE_ASSESSMENT_DATA";
export const FETCH_PRE_ASSESSMENT_DATA_SUCCESS = "FETCH_PRE_ASSESSMENT_DATA_SUCCESS";
export const FETCH_PRE_ASSESSMENT_DATA_FAILURE = "FETCH_PRE_ASSESSMENT_DATA_FAILURE";

export const ATTEMPT_FAIL_PRE_ASSESSMENT = "ATTEMPT_FAIL_PRE_ASSESSMENT";
export const ATTEMPT_FAIL_PRE_ASSESSMENT_SUCCESS = "ATTEMPT_FAIL_PRE_ASSESSMENT_SUCCESS";
export const ATTEMPT_FAIL_PRE_ASSESSMENT_FAILURE = "ATTEMPT_FAIL_PRE_ASSESSMENT_FAILURE";

export const RESET_ADD_PRE_ASSESSMENT_DATA = "RESET_ADD_PRE_ASSESSMENT_DATA";

export const FETCH_PRE_ASSESSMENT_DATA_PUBLIC = "FETCH_PRE_ASSESSMENT_DATA_PUBLIC";
export const FETCH_PRE_ASSESSMENT_DATA_PUBLIC_SUCCESS = "FETCH_PRE_ASSESSMENT_DATA_PUBLIC_SUCCESS";
export const FETCH_PRE_ASSESSMENT_DATA_PUBLIC_FAILURE = "FETCH_PRE_ASSESSMENT_DATA_PUBLIC_FAILURE";  

export const SEND_PRE_ASSESSMENT_CONSENT_EMAIL = "SEND_PRE_ASSESSMENT_CONSENT_EMAIL";
export const SEND_PRE_ASSESSMENT_CONSENT_EMAIL_SUCCESS = "SEND_PRE_ASSESSMENT_CONSENT_EMAIL_SUCCESS";
export const SEND_PRE_ASSESSMENT_CONSENT_EMAIL_FAILURE = "SEND_PRE_ASSESSMENT_CONSENT_EMAIL_FAILURE";

export const RESET_PRE_ASSESSMENT_DATA_VIDEO = "RESET_PRE_ASSESSMENT_DATA_VIDEO";

export const RESET_PRE_ASSESSMENT_VIDEO = "RESET_PRE_ASSESSMENT_VIDEO";
export const RESET_PRE_ASSESSMENT_DATA = "RESET_PRE_ASSESSMENT_DATA";

